module.exports = __webpack_public_path__ + "img/tablet.debb8a3e.png";